module.exports = __webpack_public_path__ + "static/img/S200_bg.2bcedf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/devices/S200_bg.jpg
// module id = Cg4L
// module chunks = 0